export enum DrivingLicenseFileType {
  Front,
  Back,
  Selfie,
}
